export const visit = (vm, at) => {
vm(require("documents-lib/lang/view/nl.lyaml"));
at({ "nl": { "public": { "sampleString": "Voorbeeldstring" } } });
};